import { db } from 'technical/db';

import { defectIndicatorSyncService } from './sync/defect-indicator-sync.service';
import { defectReportPictureSyncService } from './sync/defect-report-picture-sync.service';
import { defectReportSyncService } from './sync/defect-report-sync.service';
import { defectReportTypeSyncService } from './sync/defect-report-type-sync.service';
import { repairReportPictureSyncService } from './sync/repair-report-picture-sync.service';
import { repairReportSyncService } from './sync/repair-report-sync.service';
import { ringSyncService } from './sync/ring-sync.service';
import { segmentDrawConfigSyncService } from './sync/segment-draw-config-sync.service';
import { segmentSyncService } from './sync/segment-sync.service';
import { tunnelPositionSyncService } from './sync/tunnel-position-sync.service';

export const utilsDbService = {
  async isWaitingSynchronisation() {
    const unsavedRingsCount = await db.rings
      .filter((ring) => ring.desynchronizedAt !== null)
      .count();

    const unsavedDefectReportsCount = await db.defectReports
      .filter((defect) => defect.desynchronizedAt !== null)
      .count();

    const unsavedRepairReportsCount = await db.repairReports
      .filter((repair) => repair.desynchronizedAt !== null)
      .count();

    return (
      unsavedRingsCount + unsavedDefectReportsCount + unsavedRepairReportsCount
    );
  },

  async resetData() {
    await Promise.all([
      defectReportSyncService.reset(),
      defectReportPictureSyncService.reset(),
      repairReportSyncService.reset(),
      repairReportPictureSyncService.reset(),
      ringSyncService.reset(),
      segmentSyncService.reset(),
      segmentDrawConfigSyncService.reset(),
      tunnelPositionSyncService.reset(),
      defectReportTypeSyncService.reset(),
      defectIndicatorSyncService.reset(),
    ]);
  },
};
